import styled from 'styled-components';
import { SuccessNotice } from 'next/components/ui';

export const StyledNotice = styled(SuccessNotice)`
  width: 100%;

  > div {
    display: flex;
  }

  strong:nth-child(1) {
    margin-left: 16px;
    margin-right: 4px;
  }

  strong:last-child {
    margin-left: 4px;
  }

  button {
    &:focus {
      outline: none;
    }
  }
`;
